/**
 * PolicyCategoryService
 * Service for PolicyCategory entity operations
 * Route: api/policycategories
 */
import { CrudService } from '../base/CrudService';
/**
 * PolicyCategoryService
 * Handles policy category CRUD operations
 */
export class PolicyCategoryService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? PolicyCategoryService.DEFAULT_SERVICE_PATH,
            basePath: PolicyCategoryService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
PolicyCategoryService.DEFAULT_SERVICE_PATH = 'hr';
PolicyCategoryService.BASE_PATH = 'api/policycategories';
//# sourceMappingURL=PolicyCategoryService.js.map